import React, { Component } from 'react';
import './OwnerShipStyle.scss';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { REDUCER_NAME, fetchInfoBoDTooltip } from '../../reducer';
import {
  formatTextFloat,
  formatPrice,
  formatPercent,
} from '../../../../helpers/Text';
import OwnershipTooltip from './OwnershipToolip';
import TimeZoneHandle from '../../../../common/timezone-handle';

const TYPE_BUY = 'B';
const TYPE_SELL = 'S';

class TooltipBoD extends Component {
  getShareAfter = item => {
    return item.shareAcquire === 0
      ? item.shareBeforeTrade
      : item.shareAfterTrade;
  };

  getPercent = item => {
    return item.shareAcquire === 0
      ? item.ownershipBeforeTrade
      : item.ownershipAfterTrade;
  };

  renderBodyTooltip() {
    const { tooltipData } = this.props;
    if (!tooltipData.length) {
      return (
        <div style={{ height: 20 }}>
          <div className="tooltip-body-ownship-no-data">
            <span>{I18n.t('ownerShip.noData')}</span>
          </div>
        </div>
      );
    }

    return (
      <div className="div-wrapper-tooltip-body">
        {tooltipData.map(item => (
          <div className="tooltip-body-ownship" key={item.index}>
            <div
              className="children-div-body-align-left"
              style={{ width: '20%' }}
            >
              <TimeZoneHandle time={item.publicDate} format={'MM/DD/YYYY'} />
            </div>
            <div
              className="children-div-body-align-left"
              style={{ width: '10%' }}
            >
              {item.actionTypeCode === TYPE_BUY
                ? I18n.t('ownerShip.tooltipBODType.buy')
                : I18n.t('ownerShip.tooltipBODType.sell')}
            </div>
            <div
              className="children-div-body-align-right"
              style={{ width: '15%' }}
            >
              <span
                style={{
                  color:
                    item.actionTypeCode === TYPE_SELL && item.shareRegister > 0
                      ? '#eb505a'
                      : 'white',
                }}
              >
                {formatTextFloat(formatPrice(item.shareRegister))}
              </span>
            </div>
            <div
              className="children-div-body-align-right"
              style={{ width: '15%' }}
            >
              <span
                style={{
                  color:
                    item.actionTypeCode === TYPE_SELL ? '#eb505a' : 'white',
                }}
              >
                {formatTextFloat(formatPrice(item.shareAcquire))}
              </span>
            </div>
            <div
              className="children-div-body-align-right"
              style={{ width: '15%' }}
            >
              {formatTextFloat(item.shareBeforeTrade, 0)}
            </div>
            <div
              className="children-div-body-align-right"
              style={{ width: '15%' }}
            >
              {formatTextFloat(this.getShareAfter(item), 0)}
            </div>
            <div
              className="children-div-body-align-right"
              style={{ width: '15%' }}
            >
              {`${formatPercent(this.getPercent(item))} %`}
            </div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const {
      code,
      personId,
      tooltipData,
      children,
      fetchInfoBoDTooltip,
      id: componentId,
      fullName,
    } = this.props;
    const titleTooltip = I18n.t(
      'ownerShip.titleTooltip.fiveLastestTransaction',
    );
    const listTitle = I18n.t('ownerShip.listTitleTooltipBoD');

    return (
      <OwnershipTooltip
        tooltipWidth={500}
        fetchData={() => fetchInfoBoDTooltip(code, personId, componentId)}
        text={children}
        tooltipData={tooltipData}
      >
        {tooltipData && (
          <>
            <div className="tooltip-title-ownship">
              {`${titleTooltip} - ${fullName}`}
            </div>
            <div className="tooltip-header-bod-ownship">
              <div className="align-left" style={{ width: '20%' }}>
                {listTitle.AN_DATE}
              </div>
              <div className="align-left" style={{ width: '10%' }}>
                {listTitle.TYPE}
              </div>
              <div className="align-right" style={{ width: '15%' }}>
                {listTitle.REGISTER}
              </div>
              <div className="align-right" style={{ width: '15%' }}>
                {listTitle.RESULT}
              </div>
              <div className="align-right" style={{ width: '15%' }}>
                {listTitle.SHARE_BEFORE} <br />{' '}
                {`${I18n.t('ownerShip.multiLineTitleTable.BEFOR')}`}
              </div>
              <div className="align-right" style={{ width: '15%' }}>
                {listTitle.SHARE_AFTER} <br />{' '}
                {`${I18n.t('ownerShip.multiLineTitleTable.AFTER')}`}
              </div>
              <div className="align-right" style={{ width: '15%' }}>
                {listTitle.PERCENTAGE}
              </div>
            </div>

            {this.renderBodyTooltip()}
          </>
        )}
      </OwnershipTooltip>
    );
  }
}

const mapStateToProps = (state, { id, code, personId }) => ({
  tooltipData:
    state[REDUCER_NAME].listMultiComponent[id].bodTooltipInfo[
      `${code}_${personId}`
    ],
});

const mapDispatchToProps = {
  fetchInfoBoDTooltip,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TooltipBoD);
